import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { ValidationResult } from 'types';
import type { WorkOrderEntity } from './workOrder.entity';

export function validateWorkOrderSelectAcl (): boolean {
    return validateAcls([ 'work_order_select' ]);
}

export function validateWorkOrderUpdateAcl (): boolean {
    return validateAcls([ 'work_order_update' ]);
}

export const validateWorkOrderForCreation = (workOrder: WorkOrderEntity): ValidationResult => {
    if (workOrder.plannedStart !== 'now') {
        if (!workOrder.plannedStart || isNaN(workOrder.plannedStart.getTime())) {
            return {
                status: 'error',
                errorMessage: 'Planned Start is required',
            };
        }
        if (workOrder.plannedStart < new Date()) {
            return {
                status: 'error',
                errorMessage: 'Planned Start cannot be in the past',
            };
        }
    }
    return validateWorkOrder(workOrder);
};

export const validateWorkOrder = (workOrder: WorkOrderEntity): ValidationResult => {
    if (!workOrder.orderNumber) {
        return {
            status: 'error',
            errorMessage: 'Name is required',
        };
    }

    if (!workOrder.materialModelId) {
        return {
            status: 'error',
            errorMessage: 'Material Model is required',
        };
    }

    if (workOrder.targetQuantity <= 0 || isNaN(workOrder.targetQuantity)) {
        return {
            status: 'error',
            errorMessage: 'Target Quantity must be greater than zero',
        };
    }

    return { status: 'success' };
};
